import cog from './cog_icon.svg';
import { vfIcon } from '../icon/icon.js';


/**
 * Cog Icon
 *
 * @data {"attrs": {"class": "vf-icon-large"}}
 * @styleguide components.icons.cog
 */
export const vfCogIcon = {
    extends: vfIcon,

    data() {
        return {
            name: 'cog',
            graphics: cog,
        };
    },
};
